<template>
  <div v-if="show" class="devices_stat">

    <h4 class="title">
      Devices Stat
    </h4>

    <p v-for="(stat, key_stat) in devices_stat" :key="key_stat">
      <span>{{ key_stat }}: </span>
      <span>{{ stat }}</span>
    </p>


  </div>

  <div v-else style="height: 100%" >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>

<script>

export default {
  name: 'DevicesStats',
  components: {
  },
  props: ['devices_stat'],
  data () {
    return {
      loading: false,
      show: true,
      temp: '',
      date: [],
      actions: []
    }
  },

  mounted () {
  },

  watch:{

  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {

  },
}

</script>
<style lang='scss' scoped>
  .devices_stat{
    padding: 5px;
    .title{
      margin-bottom: 10px;
    }
  }
</style>
